import React, { useState } from 'react';

import { ENTER_ESCAPE } from '../../constants/key-maps';
import { mathSymbolsRegExp } from '../../constants/regular-expressions';
import HotKeys from '../hot-keys';
import { Styled } from './styled';

export const MathInput = (props) => {
  const {
    width,
    text,
    input,
    type,
    placeholder,
    autoFocus,
    autoComplete,
    maxLength,
    icon,
    textTop,
    textLeft,
    min,
    max,
    isInvalid = false,
  } = props;
  const inputProps = {
    ...input,
    type,
    placeholder,
    autoFocus,
    autoComplete,
    maxLength,
    min,
    max,
  };
  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    setMathString(input.value);
  }, [input.value]);
  const [mathString, setMathString] = useState('');
  const [mathError, setMathError] = useState(false);
  const { disabled, onChange } = input;
  const onChangeHandler = (e) => {
    if (!mathSymbolsRegExp.test(e.target.value)) {
      setMathString(e.target.value);
      setMathError(false);
    }
  };
  const onBlurHandler = () => {
    if (mathString === '') {
      onChange({ target: { value: '' } });
      return;
    }
    try {
      // eslint-disable-next-line no-eval
      const evalResult = eval(mathString);
      onChange({ target: { value: evalResult } });
    } catch (e) {
      setMathError(true);
    }
  };
  const escHandler = () => {
    setMathString(input.value);
    setMathError(false);
  };
  return (
    <HotKeys
      keyMap={ENTER_ESCAPE}
      handlers={{ escape: escHandler, enter: onBlurHandler }}
    >
      <Styled.InputContainer
        disabled={disabled}
        width={width}
        error={isInvalid || mathError}
        value={mathString}
      >
        <Styled.InputStyle
          icon={icon}
          {...inputProps}
          // eslint-disable-next-line react/jsx-no-bind
          onChange={onChangeHandler}
          // eslint-disable-next-line react/jsx-no-bind
          onBlur={onBlurHandler}
          value={mathString}
          text={text}
        />
        <Styled.InputText
          icon={icon}
          value={mathString}
          textTop={textTop}
          textLeft={textLeft}
        >
          {text}
        </Styled.InputText>
        {icon && <div>{icon}</div>}
      </Styled.InputContainer>
    </HotKeys>
  );
};
